import { onMounted, ref, onBeforeUnmount, readonly } from 'vue';
import { useNotification } from '@ui-kit';
import { EVENTS, Shopflow } from './index';
import { useDeviceInfo } from './useDeviceInfo';


export const DEFAULT_POWER_WRITE = 1;

const data = ref<number | null>(null);
const powerWrite = ref<number>(DEFAULT_POWER_WRITE);

export const usePowerRfid = () => {
  const { deviceInfo } = useDeviceInfo();
  const { show } = useNotification();

  const unsubscribeCallback = ref<(() => void) | null>(null);
  const prevPower = ref<number | null>(null);

  const set = async (newPower: number = 0, notify: boolean = false) => {
    if (!deviceInfo.value?.isRfidReader) return false;

    if (newPower === 0) return false;

    const result = await Shopflow.setRfidPower({ power: newPower });

    if (result.isPowerSetted) {
      prevPower.value = data.value;
      data.value = newPower;

      if (notify) {
        show({ title: "Мощность установлена", type: "success" });
      }

      window.dispatchEvent(new CustomEvent(EVENTS.RFID_POWER_CHANGE, { detail: { power: newPower } }));
    } else {
      if (notify) {
        show({ title: "Мощность не установлена", type: "error" });
      }
    }

    return result.isPowerSetted;
  } 

  const get = async () => {
    if (!deviceInfo.value?.isRfidReader) return 0;

    if (!data.value) {
      const result = await Shopflow.getRfidPower();

      data.value = result.power;
    }

    return data.value;
  }

  const subscribe = (callback: (power: number) => void) => {
    if (!deviceInfo.value?.isRfidReader) return;

    unsubscribe();

    const listener = (event: CustomEvent<{ power: number }>) => {
      callback(event.detail.power);
    }

    window.addEventListener(EVENTS.RFID_POWER_CHANGE, listener);

    unsubscribeCallback.value = () => {
      window.removeEventListener(EVENTS.RFID_POWER_CHANGE, listener);
    }
  }

  const unsubscribe = () => {
    if (!deviceInfo.value?.isRfidReader) return;
    
    if (unsubscribeCallback.value) {
      unsubscribeCallback.value();
      unsubscribeCallback.value = null;
    }
  }

  const setPowerWrite = (newPowerWrite: number) => {
    if (!deviceInfo.value?.isRfidReader) return;

    powerWrite.value = newPowerWrite;
  }
  
  onMounted(async () => {
    if (!data.value) {
      data.value = await get();
    }
  });

  onBeforeUnmount(unsubscribe);

  return {
    set,
    get,
    subscribe,
    unsubscribe,
    setPowerWrite,
    prevPower: readonly(prevPower),
    powerWrite: readonly(powerWrite),
  }
}
